import { render } from "./AddItemsToShipping.vue?vue&type=template&id=61e36a60"
import script from "./AddItemsToShipping.vue?vue&type=script&lang=js"
export * from "./AddItemsToShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__